import React, { useEffect, useState } from 'react';
import { Container, Typography, Paper, Button, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import documentService from '../services/documentService';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const [apiStatus, setApiStatus] = useState<'checking' | 'healthy' | 'error'>('checking');

  useEffect(() => {
    documentService.healthCheck()
      .then(() => setApiStatus('healthy'))
      .catch(() => setApiStatus('error'));
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      {apiStatus === 'checking' && <Alert severity="info">Checking API...</Alert>}
      {apiStatus === 'healthy' && <Alert severity="success">✓ Connected to API!</Alert>}
      {apiStatus === 'error' && <Alert severity="error">Cannot connect to API</Alert>}
      
      <Paper elevation={3} sx={{ p: 4, mt: 3, textAlign: 'center' }}>
        <Typography variant="h3" gutterBottom>Medical Document Processing</Typography>
        <Typography variant="h6" color="text.secondary" paragraph>
          Intelligent OCR and validation
        </Typography>
        <Button
          variant="contained"
          size="large"
          startIcon={<CloudUploadIcon />}
          onClick={() => navigate('/upload')}
        >
          Upload Document
        </Button>
      </Paper>
    </Container>
  );
};

export default Home;